import React from "react";
import themeLarge from "../../../component/ThemeLarge";
import ibtehaz from "../../../static/ibtehaz-new.jpg";
import GetToKnowMeMobile from "./GetToKnowMobile";

class IntroBody extends React.Component {

    render() {
        return (<div>
            <div
                style={{
                    background: themeLarge.colors.primary,
                    color: themeLarge.colors.bg,
                    padding: "30px 15px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                {/* Text */}
                <div style={{ flex: 1 }}>
                    <p
                        style={{
                            fontSize: themeLarge.fontSize.display,
                            fontFamily: "Noto Sans",
                            margin: 0,
                        }}
                    >
                        Hi <br />
                        I am <br />
                        Ibtehaz
                    </p>
                </div>

                {/* Image */}
                <div style={{ marginLeft: "10px" }}>
                    <img
                        src={ibtehaz}
                        width="130px"
                        style={{ borderRadius: "15px" }}
                        alt="Ibtehaz"
                    />
                </div>
            </div>
            <GetToKnowMeMobile />
            
        </div>)
    }
}

export default IntroBody;